/* eslint-disable default-param-last */
// Action types
const SAVE_USERDATA = "spirit/auth/SAVE_USERDATA";
const SAVE_BACKEND_TOKEN = "spirit/auth/SAVE_BACKEND_TOKEN";
const SAVE_PROFILE_TOKEN = "spirit/auth/SAVE_PROFILE_TOKEN";
const CLEAR_DATA = "spirit/auth/CLEAR_DATA";
const LOGOUT = "spirit/auth/LOGOUT";

// InitialState
export const initialState = {
  accessToken: undefined,
  refreshToken: undefined,
  profileToken: undefined,
  expirationDate: undefined,
  userdata: undefined,
};

// Reducers
export default (state = initialState, action) => {
  switch (action.type) {
    case SAVE_USERDATA:
      return {
        ...state,
        userdata: action.data,
      };
    case SAVE_BACKEND_TOKEN:
      return {
        ...state,
        accessToken: action.accessToken,
        refreshToken: action.refreshToken,
        expirationDate: action.expirationDate,
      };
    case SAVE_PROFILE_TOKEN:
      return {
        ...state,
        profileToken: action.token,
      };
    case CLEAR_DATA:
    case LOGOUT:
      return initialState;
    default:
      return state;
  }
};

// Action Creators
export const saveBackendToken = (auth) => ({
  type: SAVE_BACKEND_TOKEN,
  accessToken: auth.accessToken,
  refreshToken: auth.refreshToken,
  expirationDate: auth.expirationDate,
});

export const saveProfileToken = (token) => ({
  type: SAVE_PROFILE_TOKEN,
  token,
});

export const saveUserdata = (data) => ({
  type: SAVE_USERDATA,
  data,
});

export const logout = () => ({
  type: LOGOUT,
});

export const clearData = () => ({
  type: CLEAR_DATA,
});
